//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'

export default {
    data() {
        return {
            sm: ''
        }
    },
    mounted() {
        document.querySelector('footer').style.display = 'none'
        this.$nextTick(function () {
            this.checkMobile()
        })
        window.addEventListener('resize', this.checkMobile)
    },
    computed: {
        copyright() {
            return `© ${moment().format('YYYY')} Perkins LLC All rights reserved.`
        },
        mq() {
            return this.$mq
        }
    },
    methods: {
        checkMobile() {
            this.sm = (window.innerWidth < 640) ? 1 : 0
        }
    }
}
